
export enum CUSTOM_LAUNCH_CALLER {
  CART_DELETE = 'CART_DELETE',
  CART_PRODUCT_SEARCH_RESULT = 'CART_PRODUCT_SEARCH_RESULT',
  MANUFACTURERS_SELECTION = 'MANUFACTURERS_SELECTION',
  ORDER_LIMIT_EXCEEDED = 'ORDER_LIMIT_EXCEEDED',
  CART_LIMIT_EXCEEDED = 'CART_LIMIT_EXCEEDED',
  CONSENT_MANAGEMENT = 'CONSENT_MANAGEMENT',
  CART_EXPORT = 'CART_EXPORT',
  CART_IMPORT = 'CART_IMPORT',
  CART_IMPORT_SELECTION = 'CART_IMPORT_SELECTION',
  MINI_CART = 'MINI_CART'
}

